import { Currency } from '@constants'
import { roundNumber } from '@dni-utils/round-number'

export const CurrencyMap: Record<string, string | undefined> = {
  HKD: 'HK',
  TWD: 'NT',
  SGD: 'SG',
  USD: 'US',
  MYR: 'RM',
}

/**
 * 各幣別小數位數 (依 ISO 4217 minor unit)
 * - TWD：0 位 (台幣不含小數)
 * - HKD / SGD / MYR / USD：2 位
 */
const CURRENCY_DECIMAL_DIGITS: Record<Currency, number> = {
  [Currency.TWD]: 0,
  [Currency.HKD]: 2,
  [Currency.SGD]: 2,
  [Currency.MYR]: 2,
  [Currency.USD]: 2,
}

const DEFAULT_DECIMAL_DIGITS = 2

export const getCurrencyDecimalDigits = (currencyKey: string | undefined): number => {
  if (currencyKey && currencyKey in CURRENCY_DECIMAL_DIGITS) {
    return CURRENCY_DECIMAL_DIGITS[currencyKey as Currency]
  }
  return DEFAULT_DECIMAL_DIGITS
}

/**
 * TODO: Add tests
 * @deprecated Please use formatPrice instead
 */
export const formatCurrency = (currencyKey?: string, value?: number, formatter = 'currency$value', defaultValue = '-') => {
  const localeValue = value?.toLocaleString()
  if (!currencyKey) return localeValue

  const currency = CurrencyMap[currencyKey] || ''
  return formatter.replace('value', localeValue !== undefined ? String(localeValue) : defaultValue).replace('currency', currency)
}

/**
 * 依幣別小數位數格式化金額顯示
 * - TWD：整數
 * - HKD / SGD / MYR / USD：2 位小數
 * - 未指定 currencyKey：原值 passthrough，不四捨五入
 *
 * @example
 *   formatPrice('TWD', 399.6)   // '$400'
 *   formatPrice('USD', 399.567) // '$399.57'
 */
export const formatPrice = (currencyKey?: string, value?: number, formatter = '$value', defaultValue = '-') => {
  if (!currencyKey) return value?.toLocaleString()

  const roundedValue = value !== undefined ? roundNumber(value, getCurrencyDecimalDigits(currencyKey)) : undefined
  const localeValue = roundedValue?.toLocaleString()
  return formatter.replace('value', localeValue !== undefined ? String(localeValue) : defaultValue)
}
